import { createAsyncThunk } from '@reduxjs/toolkit'
import Api, { paths } from 'shared/services/Api'
import {
  Added,
  Connection,
  ImportData,
  InvoiceKSeFRequest,
  InvoiceKSeFResponse,
  SummaryData,
} from 'shared/types'
import { downloadFile } from 'shared/utils'
const NAMESPACE = 'ksef'

export const updateToken = createAsyncThunk<string, string, {}>(
  `${NAMESPACE}/updateToken`,
  async (payload, thunkAPI) => {
    try {
      const response = await Api.post<string>(`${paths.Ksef.token}/${payload}`)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)

export const deleteToken = createAsyncThunk<void, undefined>(
  `${NAMESPACE}/deleteToken`,
  async (_, thunkAPI) => {
    try {
      await Api.delete(`${paths.Ksef.token}`)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)

export const checkTokenActivity = createAsyncThunk<Connection>(
  `${NAMESPACE}/checkTokenActivity`,
  async (_, thunkAPI) => {
    try {
      const response = await Api.get<Connection>(`${paths.Ksef.connection}`)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)

export const checkAdded = createAsyncThunk<Added>(
  `${NAMESPACE}/checkAdded`,
  async (_, thunkAPI) => {
    try {
      const response = await Api.get<Added>(`${paths.Ksef.token}`)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)

export const fetchKsefInvoices = createAsyncThunk<
  InvoiceKSeFResponse,
  { from: string; to: string }
>(
  `${NAMESPACE}/fetchKsefInvoices`,
  async ({ from, to }, thunkAPI) => {
    try {
      const response = await Api.get(`${paths.Ksef.invoices}`, {
        params: {
          from,
          to,
        },
      })
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)

export const sendInvoices = createAsyncThunk<string, InvoiceKSeFRequest, {}>(
  `${NAMESPACE}/sendInvoices`,
  async (payload, thunkAPI) => {
    try {
      const response = await Api.post<string>(`${paths.Ksef.invoices}`, payload)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)
export const getKsefImports = createAsyncThunk<ImportData[]>(
  `${NAMESPACE}/getKsefImports`,
  async (_, thunkAPI) => {
    try {
      const response = await Api.get<ImportData[]>(`${paths.Ksef.sessions}`, {})
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)

export const rerunImport = createAsyncThunk<void, string>(
  `${NAMESPACE}/rerunImport`,
  async (payload, thunkAPI) => {
    try {
      await Api.get(`${paths.Ksef.rerun}/${payload}`)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)

export const cancelImport = createAsyncThunk<void, string>(
  `${NAMESPACE}/cancelImport`,
  async (payload, thunkAPI) => {
    try {
      await Api.delete(`${paths.Ksef.sessions}/${payload}`)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)

export const getImportSummary = createAsyncThunk<SummaryData, string>(
  `${NAMESPACE}/getImportSummary`,
  async (payload, thunkAPI) => {
    try {
      const response = await Api.get<SummaryData>(
        `${paths.Ksef.sessions}/${payload}`
      )
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)

export const downloadReportFile = createAsyncThunk<
  void,
  { fileName: string; id: number },
  { rejectValue: string }
>(
  `${NAMESPACE}/downloadReportFile`,
  async ({ fileName, id }, { rejectWithValue }) => {
    try {
      const response = await Api.get<string>(`${paths.Ksef.summary}/${id}`, {
        responseType: 'blob',
      })
      const blob = response.data
      downloadFile(blob, fileName)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const hideMessage = createAsyncThunk<void, number>(
  `${NAMESPACE}/hideMessage`,
  async (payload, thunkAPI) => {
    try {
      await Api.put(`${paths.Ksef.displayed}/${payload}`)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {}
)
